// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3qCiY","calendarButtons":"ClockData_calendarButtons__1nJhl"};